import { BuzzTestStatus } from './models/BuzzTest';
import { Status as CourseStatus } from './models/CourseLessonContentTO';
import { Status as LessonStatus } from './models/LessonContentTO';
import { ProgramStatus, ProgramType } from './models/Program';
import { RadialChartType } from './models/RadialChart';
import { ReportProcessStatus } from './models/ReportProcess';
import { Status } from './models/Status';

export default {
    API_PATH: '/rest/',
    APP_KEY: 'flow',
    APP_ID: 11,
    APP_TITLE: 'Afferolab.Flow',
    APP_TOTVS_TITLE: 'LXP by Afferolab',
    PLAYLIST_MODULE_ID: 1,
    LMS_MODULE_ID: 2,
    BUZZ_MODULE_ID: 3,
    DOMAIN: 'afferolab.net',
    LOGIN_URI: 'cast/login',
    LOGIN_INTEGRATION_URI: 'cast/login/integration',
    CHANGE_PASSWORD_URI: 'security/users',
    PASSWORD_RULES_URI: 'security/password-configurations/organizations/%o',
    FORGOT_PASSWORD_URI: 'cast/users/forgot-password',
    APP_ORG_URI: 'organization/app-organizations',
    ORG_LOGO: '/static/assets/orgs/%s/apps/%s/img/org-logo.png',
    ORG_BANNER: '/static/assets/orgs/%s/apps/%s/img/org-banner.png',
    FEEDBACK_URI: 'cast/email',
    TAGS_URI: 'lms/tags',
    CATEGORIES_URI: 'lms/categories',
    CATEGORIES_CAST_URI: 'cast/categories',
    ITENS_URI: 'lms/contents',
    LMS_COURSES_URI: 'lms/courses',
    LMS_COURSES_VIEWS: 'lms/courses/%s/views',
    LESSONS_URI: 'lms/lessons',
    USER_URI: 'security/users',
    USERS_URI: 'person/persons',
    PEOPLE_URI: 'person/persons',
    USER_IMPORT_URI: 'person/imports',
    PERSON_SET_LOCALE_URI: 'person/persons/%p/locale',
    LMS_CONTENT_LOCALE_URI: 'lms/students/%p/locales',
    ACCEPT_TERMS_URI: 'person/persons/%p/terms',
    S3_SECURITY_URI: 'security/s3/credentials',
    LMS_CONTENTS_URI: 'lms/students/%p/contents',
    CONTENTS_URI: 'cast/students/contents',
    LMS_STUDENT_COURSES_URI: 'lms/students/%s/courses',
    FAVORITE_COURSE_URI: 'person/favorites/COURSE/%s',
    FAVORITE_CONTENT_URI: 'person/favorites/CONTENT/%s',
    FAVORITE_CATEGORY_URI: 'person/favorites/CATEGORY/%s',
    FAVORITE_PROGRAM_URI: 'person/favorites/PROGRAM/%s',
    FAVORITE_LIST_URI: 'person/favorites',
    RECOMMENDATION_LIST_URI: 'person/recommendations',
    CONTENT_STUDENT_VIEW_URI: 'lms/students/%p/contents/%c',
    ATTACHMENTS_CONTENT_URI: 'lms/attachments/contents',
    ATTACHMENTS_DELETE_URI: 'lms/attachments/%s',
    ATTACHMENTS_URI: 'lms/attachments',
    CAST_HIGHLIGHT_URI: 'cast/highlights',
    SOCIAL_HIGHLIGHT_URI: 'social/highlights',
    TRACKING_AWS: 'tracking/aws',
    START_CONTENT_URI: 'lms/contents/%s/start',
    FINISH_CONTENT_URI: 'lms/contents/%s/finish',
    START_LESSON_URI: 'lms/lessons/%s/start-enrollment',
    FINISH_LESSON_URI: 'lms/lessons/%s/finish-enrollment',
    COURSE_STUDENT_VIEW_URI: 'lms/students/%p/courses/%c',
    SOCIAL_CLASSIFICATIONS_URI: 'social/classifications',
    SOCIAL_COURSE_RATING_URI: 'social/contents/courses/%s/ratings',
    SOCIAL_CONTENT_RATING_URI: 'social/contents/contents/%s/ratings',
    SOCIAL_PROGRAM_RATING_URI: 'social/contents/programs/%s/ratings',
    SOCIAL_COURSE_OWN_RATE_URI: 'social/people/%p/contents/courses/%c',
    SOCIAL_CONTENT_OWN_RATE_URI: 'social/people/%p/contents/contents/%c',
    DASHBOARD_URI: 'tracking/reports/dashboards/%s?applicationId=%a',
    SOCIAL_PROGRAM_OWN_RATE_URI: 'social/people/%p/contents/programs/%c',
    SOCIAL_FOLLOW_URI: 'social/persons/%p/followers',
    SOCIAL_UNFOLLOW_URI: 'social/persons/%p/followers/%c',
    SOCIAL_BATCH_FOLLOW_URI: 'social/persons/%p/batch-following-update',
    CAST_FOLLOW_URI: 'cast/persons/%p/followers',
    CAST_FOLLOWING_URI: 'cast/persons/%p/following',
    TRACKING_METADATA_URI: 'tracking/metadata',
    TRACKING_REPORTS: 'tracking/reports',
    TRACKING_REPORTS_PAGINATION: 'tracking/reports?applicationId=%a&organizationId=%o&profileId=4&limit=20&offset=0',
    CAST_CONTENTS_SEARCH_URI: 'cast/searches/contents',
    CAST_COURSES_SEARCH_URI: 'cast/searches/courses',
    CAST_PROGRAMS_SEARCH_URI: 'cast/searches/programs',
    CAST_SUGGESTIONS_URI: 'cast/searches/suggestions',
    CAST_PEOPLE_SEARCH_URI: 'cast/searches/people',
    CAST_PEOPLE_ATTRIBUTES_SEARCH_URI: 'cast/searches/people/attributes?term=%t&fields=%f',
    CAST_CURRENT_LEARNING_MAP_URI: 'cast/learning-maps/current',
    CAST_HISTORY_LEARNING_MAP_URI: 'cast/learning-maps/history',
    CAST_PERSON_CATEGORIES_DATA_URI: 'cast/persons/categories-data',
    PERSON_SEARCH_HISTORY_URI: 'person/searches',
    MESSAGE_NOTIFICATIONS_URI: 'message/notifications',
    MESSAGE_CHECK_NOTIFICATION_URI: 'message/notifications/%n',
    FLOWLMS_PROGRAM_CLASS_URI: 'flowlms/courses/%c/program-classes',
    FLOWLMS_PROGRAM_COURSE_URI: 'flowlms/programs/%p/courses/%c',
    FLOWLMS_PROGRAM_CLASS_FOR_COURSE_URI: 'flowlms/courses/%c/program-classes',
    FLOWLMS_PROGRAM_CLASS_FOR_PROGRAM_URI: 'flowlms/programs/%c/program-classes',
    LMS_PROGRAM_CLASS_URI: 'lms/program-classes',
    LMS_PROGRAM_CLASS_BY_COURSE_URI: 'lms/program-classes/courses/%c',
    LMS_PROGRAM_CLASS_ENROLL_INFO_URI: 'lms/program-classes/%p/enroll-info',
    LMS_PROGRAM_CLASS_TEMPLATE_URI: '/rest/lms/program-classes/import-template?token=%t',
    LMS_PROGRAM_CLASS_MASS_IMPORT_URI: '/lms/program-classes/%p/enrollment-processes',
    LMS_PROGRAM_CLASS_MASS_IMPORT_DETAILS_URI: '/lms/program-classes/%p/enrollment-processes/%e',
    LMS_ERROR_PROGRAM_CLASS_IMPORT_URI: '/rest/lms/program-classes/%p/enrollment-processes/%e/results?status=COMPLETED_WITH_ERRORS&token=%t',
    FLOWLMS_PEOPLE_URI: 'flowlms/persons',
    FLOWLMS_COURSES_URI: 'flowlms/courses',
    FLOWLMS_LESSONS_URI: 'flowlms/lessons/evaluation',
    FLOWLMS_LESSONS_QUESTIONS_URI: 'flowlms/lessons/evaluation/questions/%questionId',
    FLOWLMS_DELETE_QUESTIONS_URI: 'flowlms/lessons/%lessonId/questions/%questionId',
    FLOWLMS_LESSONS_EVALUATION_URI: 'flowlms/lessons/%lessonId/evaluation',
    FLOWLMS_COURSE_STUDENT_VIEW_URI: 'flowlms/students/%p/courses/%c',
    FLOWLMS_COURSE_CERTIFICATE_URI: 'flowlms/students/%personId/course-enrollments/%courseEnrollmentId/certificate?token=%token',
    FLOWLMS_PROGRAM_CERTIFICATE_URI: `flowlms/students/%personId/class-enrollments/%classEnrollmentId/certificate?token=%token`,
    FLOWLMS_QUESTIONS_URI: 'flowlms/lessons/%lessonId/questions',
    LMS_CLASS_ENTOLLMENTS_URI: 'lms/class-enrollments',
    EVALUATION_QUESTIONS_URI: 'evaluation/questions',
    EVALUATION_TOPICS_URI: 'evaluation/topics',
    EVALUATION_QUESTIONNAIRES_RESOURCE: 'evaluation/questionnaires',
    EVALUATION_QUESTIONNAIRES_BY_ID_URI: 'evaluation/evaluations/%e/questionnaires',
    SCORM_CDN_TEST_START_URI: 'scorm/service/cdn-test/start',
    LMS_PROGRAMS_URI: 'lms/programs',
    LMS_PROGRAM_URI: 'lms/programs/%p',
    CAST_PERSONS_ONBOARD_URI: 'cast/persons/onboard',
    LMS_PROGRAM_COURSES_URI: 'lms/programs/%p/courses',
    LMS_PROGRAM_PREREQUISITES: 'lms/programs/%p/prerequisites',
    LMS_GET_PROGRAM_LIST_STUDENT_VIEW: 'lms/students/%p/programs',
    FLOWLMS_PROGRAM_COURSE_REORDER_URI: 'flowlms/programs/%p/courses/%c/reorder/%o',
    FLOWLMS_PROGRAM_COURSES_URI: 'flowlms/programs/%p/courses/%c',
    FLOWLMS_PROGRAM_SET_PREREQUISITES: 'flowlms/programs/%p/prerequisites',
    FLOWLMS_GET_PROGRAM_CLASS_STUDENT_VIEW: 'flowlms/students/%p/program-student-views/%c/programs/%programId',
    CAST_BOTS_RECOMMENDATIONS_URI: 'cast/bots/recommendations',
    CAST_BOTS_SELECT_RECOMMENDATION_URI: 'cast/bots/recommendations/%r/contents/%c',
    CAST_BOTS_EVENTS_URI: 'cast/bots/events/%p',
    BUZ_QUIZZES: 'buzz/quizzes',
    QUIZ_QUIZZES: 'quiz/quizzes',
    QUIZ_RESULTS: 'quiz/results',
    QUIZ_QUESTIONS: 'quiz/questions',
    QUIZ_QUIZZES_AUTO_EXECUTE: 'quiz/quizzes/auto-execute',
    BATCH_FAVORITE_URI: 'person/favorites/batch/%s',
    CHAT_SEND_MESSAGE_URI: 'cast/bots/messages',
    GET_ORGANIZATION_STATS_URI: 'lms/organizations/%orgId/applications/%appId/stats',
    LMS_START_ENROLLMENT: 'lms/students/%p/courses/%c/start-enrollment',
    CAST_GET_ACHIEVEMENTS_URI: 'cast/students/%p/achievements',
    CAST_ACHIEVEMENTS_NOTIFICATION_READ_URI: 'cast/person-badges/%personBadgeId/notification-read',
    CAST_ACHIEVEMENTS_INFO_READ_URI: 'cast/persons/achievements-info-read',
    SEARCH_RESULT_URL: '/search-result',
    LMS_PROGRAM_VIEWS: 'lms/programs/%programId/views',
    LOGIN_SAML_URI: 'security/login/saml/',
    LOGIN_SAML_CALLBACK_URL: '#/saml',
    LOGIN_BEARER_URI: 'cast/login/bearer',
    LMS_GET_FAMILY_LIST: 'lms/families/applications/%appId',
    GROUPS_RESULT_URI: 'person/groups',
    LMS_AUTOMATIC_ENROLLMENT_URI: 'lms/automatic-enrollment-rule',

    language: {
        EN: 'en',
        PT: 'pt',
    },
    SUPPORT_EMAIL: 'support.flow@afferolab.com',
    APP_EMAIL: 'flow@afferolab.net',
    FEEDBACK_EMAIL_SUBJECT: ' Afferolab.Flow - FEEDBACK (WEB)',
    USER_ORDER_BY_NAME: '{"pd.firstName":"asc","pd.lastName":"asc"}',
    USER_ORDER_BY_NEWS: '{"p.creationDate":"desc"}',
    icons: {
        ALARM: 'alarm',
        LOCK: 'lock',
        VISIBILITY: 'visibility',
        VISIBILITY_OFF: 'visibility_off',
        VERIFIED: 'verified',
        KEY_OUTLINE: 'key-outline',
        ALERT_ERROR: 'error',
        SMS_FAILED: 'sms_failed',
        FAVORITE: 'favorite',
        FAVORITE_BORDER: 'favorite_border',
        STAR_OUTLINE: 'star_outline',
        CHEVRON_LEFT: 'chevron_left',
        IMAGE_OUTLINE: 'image',
        AUDIOTRACK: 'audiotrack',
        ONDEMAND_VIDEO: 'ondemand_video',
        FILE_DOCUMENT_OUTLINE: 'description',
        PDF: 'picture_as_pdf',
        INSERT_DRIVE_FILE: 'insert_drive_file',
        ATTACH_OUTLINE: 'attach_file',
        COMMENTS: 'mode_comment',
        PAUSE_CIRCLE_FILLED: 'pause_circle_filled',
        PLAY_CIRCLE_FILLED: 'play_circle_filled',
        REPLAY_10: 'replay_10',
        FORWARD_10: 'forward_10',
        FULLSCREEN: 'fullscreen',
        FULLSCREEN_EXIT: 'fullscreen_exit',
        CHECK: 'check',
        CLOSE: 'close',
        DONE: 'done',
        MORE_HORIZ: 'more_horiz',
        STAR: 'star',
        STAR_BORDER: 'star_border',
        HTTPS: 'https',
        REFRESH: 'refresh',
        VIDEOCAM: 'videocam',
        LINK: 'link',
        MICROPHONE: 'mic_none',
        CHECK_CIRCLE: 'check_circle',
        UNCHECK_CIRCLE: 'radio_button_unchecked',
        ARROW_DROP_DOWN: 'arrow_drop_down',
        ARROW_DROP_UP: 'arrow_drop_up',
        ARROW_RIGHT: 'keyboard_arrow_right',
        ARROW_LEFT: 'keyboard_arrow_left',
        KEYBOARD_ARROW_DOWN: 'keyboard_arrow_down',
        KEYBOARD_ARROW_UP: 'keyboard_arrow_up',
        INFO_OUTLINE: 'info_outline',
        PERSON: 'person',
        DELETE: 'delete',
        UNDO: 'undo',
        SEARCH: 'search',
        NOTIFICATIONS: 'notifications',
        VPN_KEY: 'vpn_key',
        COLORIZE: 'colorize',
        REPORT_PROBLEM: 'report_problem',
        LANGUAGE: 'language',
        ADD_CIRCLE_OUTLINE: 'add_circle_outline',
        ACCESS_TIME: 'access_time',
        ANNOUNCEMENT: 'announcement',
        ERROR_OUTLINE: 'error_outline',
        BACKUP: 'backup',
        SAVE: 'save',
        EDIT: 'edit',
        SCHOOL: 'school',
        ADD: 'add',
        ADD_BASELINE: 'baseline_add',
        COURSES_PROGRAM: 'chrome_reader_mode',
        LIST_ALT: 'list_alt',
        BALLOT: 'ballot',
        PEOPLE: 'people',
        CALENDAR_TODAY: 'calendar_today',
        CLOUD_UPLOAD: 'cloud_upload',
        CIRCLE: 'circle',
        CIRCLE_MINUS: 'remove_circle_outline',
        CIRCLE_PLUS: 'add_circle_outline',
        TRASH_CAN: 'delete_outline',
        CHART: 'insert_chart_outlined',
        RUN: 'directions_run',
        INVALID_CROSS: 'highlight_off',
        VALID_CHECK: 'check_circle_outline',
        ASSIGNMENT: 'assignment',
        DRAG_INDICATOR: 'drag_indicator',
        OUTLINED_FLAG: 'outlined_flag',
        GESTURE: 'gesture',
        HOW_TO_VOTE: 'how_to_vote',
        SEND: 'send',
        SUNRISE: 'sunrise',
        SUN: 'sun',
        MOON: 'moon',
        SHOW_CHART: 'show_chart',
        THUMB_UP: 'thumb_up',
        SCALE_BALANCE: 'scale_balance',
        TABLE_VIEW: 'table_view',
        SAVE_ALT: 'save_alt',
        PERM_IDENTITY: 'perm_identity',
        PUBLIC_OFF: 'public_off',
        PUBLIC: 'public',
        RADIO_BUTTON_CHECKED: 'radio_button_checked',
        RADIO_BUTTON_UNCHECKED: 'radio_button_unchecked',
        LIGHTBULB: 'lightbulb',
        CAMERA_ALT: 'camera_alt',
        REPLY_BACK: 'reply_back',
        GROUP: 'group',
        FILTER_ALT_OUTLINED: 'filter_alt_outlined',
        CHECK_BOX: 'check_box',
        CHECK_BOX_OUTLINE_BLANK: 'check_box_outline_blank',
        FILE_COPY: 'file_copy',
        TARGET: 'adjust',
    },
    STUDENT_HOME_SCREEN_SIZE: 1200,
    CATEGORY: 'category',
    courseStatus: { DRAFT: 'DRAFT' as CourseStatus, PUBLISHED: 'PUBLISHED' as CourseStatus, ARCHIVED: 'ARCHIVED' as CourseStatus },
    lessonStatus: { DRAFT: 'DRAFT' as LessonStatus, PUBLISHED: 'PUBLISHED' as LessonStatus, ARCHIVED: 'ARCHIVED' as LessonStatus },
    courseEnrollmentStatus: {
        BLOCKED: 'BLOCKED' as Status,
        NOT_STARTED: 'NOT_STARTED' as Status,
        STARTED: 'STARTED' as Status,
        COMPLETED: 'COMPLETED' as Status,
        INCOMPLETE: 'INCOMPLETE' as Status,
        PASSED: 'PASSED' as Status,
        FAILED: 'FAILED' as Status,
    },
    lessonEnrollmentStatus: {
        COMPLETED: 'COMPLETED' as Status,
        INCOMPLETE: 'INCOMPLETE' as Status,
        NOT_ATTEMPTED: 'NOT_ATTEMPTED' as Status,
        PASSED: 'PASSED' as Status,
        FAILED: 'FAILED' as Status,
    },
    contentEnrollmentStatus: {
        INCOMPLETE: 'INCOMPLETE' as Status,
        COMPLETED: 'COMPLETED' as Status,
        NOT_ATTEMPTED: 'NOT_ATTEMPTED' as Status,
        PASSED: 'PASSED' as Status,
        FAILED: 'FAILED' as Status,
    },
    programEnrollmentStatus: {
        BLOCKED: 'BLOCKED' as Status,
        NOT_STARTED: 'NOT_STARTED' as Status,
        STARTED: 'STARTED' as Status,
        COMPLETED: 'COMPLETED' as Status,
        INCOMPLETE: 'INCOMPLETE' as Status,
        PASSED: 'PASSED' as Status,
        FAILED: 'FAILED' as Status,
    },
    reportProcessStatus: {
        NOT_STARTED: 'NOT_STARTED' as ReportProcessStatus,
        STARTED: 'STARTED' as ReportProcessStatus,
        COMPLETED_WITH_ERRORS: 'COMPLETED_WITH_ERRORS' as ReportProcessStatus,
        COMPLETED: 'COMPLETED' as ReportProcessStatus,
    },
    VIEW_TYPE_RESOURCE_NEW_REALEASES: 'new-releases',
    VIEW_TYPE_RESOURCE_TRENDING: 'trending',
    VIEW_TYPE_RESOURCE_IN_PROGRESS: 'in-progress',
    VIEW_TYPE_RESOURCE_COMPLETED: 'completed',
    VIEW_TYPE_RESOURCE_TOP_RATED: 'top-rated',
    VIEW_TYPE_RESOURCE_FAVORITES: 'favorites',
    VIEW_TYPE_RESOURCE_LIKE_YOU: 'like-you',
    VIEW_TYPE_RESOURCE_FOR_YOU: 'for-you',
    VIEW_TYPE_RESOURCE_SEARCH_RESULT: 'search-result',
    VIEW_TYPE_RESOURCE_ESSENTIALS: 'essentials',
    SIMPLIFIED_CONTENT_LIMIT_WITHOUT_COURSE: 4,
    SIMPLIFIED_CONTENT_LIMIT_WITH_COURSE: 2,
    CONTENT_LIMIT: 10,
    COURSE_SECTION_PAGINATION_LIMIT: 12,
    COMMENTS_PAGINATION_LIMIT: 3,
    RECOMMENDED_CONTENTS_RESOURCE_NAME: 'contents',
    entityTypes: {
        LESSON: 'LESSON',
        COURSE: 'COURSE',
        CONTENT: 'CONTENT',
        CATEGORY: 'CATEGORY',
        BUZZTEST: 'BUZZTEST',
        PROGRAM: 'PROGRAM',
    },
    SECTIONS_RESOURCE_NAME: 'sections',
    CONTENTS_RESOURCE_NAME: 'contents',
    PUBLIC_PROFILE_RESOURCE_NAME: 'profile/%p/info',
    imageTypesList: ['png', 'jpg', 'jpeg', 'gif'],
    audioTypesList: ['mp3'],
    videoTypesList: ['avi', 'mp4', 'webm', 'mpeg'],
    docsTypesList: ['doc', 'docx', 'txt', 'xls', 'xlsx', 'ppt', 'pptx'],
    pdfTypeList: ['pdf'],
    listCategorizedPrefix: 'listCategorized',
    CONTENT_GO_BACK_BAR_ID: 'content_go_back_bar',
    TOP_IMG_ID: 'top_img',
    COMMENTS_SECTION_ID: 'comments',
    COURSES_RESOURCE_NAME: 'courses',
    LESSONS_RESOURCE_NAME: 'lessons',
    PROGRAMS_RESOURCE_NAME: 'programs',
    EVALUATIONS_RESOURCE_NAME: 'evaluations',
    ATTACHMENTS_SECTION_ID: 'attachments',
    VIDEO_TYPE: 'VIDEO',
    AUDIO_TYPE: 'AUDIO',
    EXTERNAL_TYPE: 'EXTERNAL',
    HTML_TYPE: 'HTML',
    RATING_SECTION_ID: 'rating',
    HR_PROFILE: 'HR',
    STUDENT_PROFILE: 'STUDENT',
    SUCCESS: 'success',
    ERROR_STATUS: 'error',
    TAG_REQUEST_DEFAULT_LIMIT: 12,
    TAG_REQUEST_DEFAULT_OFFSET: 0,
    PROGRAMS_LMS_SCREEN_ROUTE: 'lms/enrollments/%e/programs/%p',
    statusCode: {
        ENTITY_NOT_FOUND: 464,
        UNAUTHORIZED: 401,
        INVALID_PASSWORD_FORMAT_STATUS: 480,
        PRECONDITION_FAILED: 412,
        LESSONS_SIZE_INVALID_STATUS: 466,
        ENTITY_ALREADY_EXISTS: 487,
        FORBIDDEN: 403,
    },
    headerMenuOptions: {
        PROFILE: 'profile',
        LANGUAGE: 'lang',
        FEEDBACK: 'feedback',
        PASSWORD: 'pass',
        PASSWORD_FIRST_TIME: 'pass-first-time',
        TERMS_OF_USE: 'terms-of-use',
        ONBOARDING_WHITELABEL: 'onboarding-whitelabel',
    },
    modal: {
        MORE_OPTIONS: 'moreOptionsModal',
        LIST_CREATION_MODAL: 'listCreationModal',
        ACHIEVEMENT: 'achievementModal',
        CONFIRMATION_MODAL: 'confirmationModal',
        ACTIVATE_INACTIVATE_RESULT_MODAL: 'resultModal',
        COULD_NOT_INACTIVATE_CATEGORY_MODAL: 'couldNotInactivateCategoryModal',
        MORE_OPTIONS_VISIBILITY: 'moreOptionsModalVisibility',
    },

    contentMoreOptions: {
        MENU: 'menu',
    },
    scormStatus: {
        PROCESSING: 'PROCESSING',
        SUCCESS: 'SUCCESS',
        ERROR: 'ERROR',
    },
    scormCdnTest: {
        COOKIE_NAME: 'cdntst',
        PASSED: 'passed',
        FAILED: 'failed',
    },

    lesson: {
        mediaType: {
            HTML: 'HTML',
            EXTERNAL: 'EXTERNAL',
            VIDEO: 'VIDEO',
            AUDIO: 'AUDIO',
            DOCUMENT: 'DOCUMENT',
            CHART: 'CHART',
        },
        type: {
            ScormLesson: 'ScormLesson',
            MediaLesson: 'MediaLesson',
            EvaluationLesson: 'EvaluationLesson',
        },
    },
    symbol: {
        ASTERISK: '*',
    },
    mobileApp: {
        ANDROID_PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.afferolab.cast',
        IOS_APP_STORE: 'https://apps.apple.com/app/afferolab-flow/id1473309133',
        APP_INTEGRATION_DEEP_LINK: 'afferolabflow://integration',
        APP_HOME_DEEP_LINK: 'afferolabflow://home',
        APP_HOME_DEEP_LINK_TOTVS: 'afferolablxp://home',
        APP_RECOMMENDATIONS_DEEP_LINK: 'afferolabflow://mainStack/DefaultStack/ContentStack/Content?contentId=',
        APP_LMS_DEEP_LINK: 'afferolabflow://RedirectStack/LMSRedirect?classId=',
        ANDROID_PLAY_STORE_TOTVS: 'https://play.google.com/store/apps/details?id=com.afferolab.lxp.totvs',
        IOS_APP_STORE_TOTVS: 'https://apps.apple.com/app/lxp-by-afferolab/id6443801747',
    },
    programStatus: {
        DRAFT: 'DRAFT' as ProgramStatus,
        PUBLISHED: 'PUBLISHED' as ProgramStatus,
        ARCHIVED: 'ARCHIVED' as ProgramStatus,
    },
    programTypes: {
        READY: 'READY' as ProgramType,
        BUILDING: 'BUILDING' as ProgramType,
    },
    classEnrollmentStatus: {
        NOT_STARTED: 'NOT_STARTED' as Status,
        NOT_COMPLETED: 'NOT_COMPLETED' as Status,
        COMPLETED: 'COMPLETED' as Status,
        PASSED: 'PASSED' as Status,
        FAILED: 'FAILED' as Status,
        EXPIRED: 'EXPIRED' as Status,
    },
    buzzTestStatus: {
        DRAFT: 'DRAFT' as BuzzTestStatus,
        PUBLISHED: 'PUBLISHED' as BuzzTestStatus,
        ARCHIVED: 'ARCHIVED' as BuzzTestStatus,
    },
    reactQuillAvailableFormats: [
        'bold',
        'italic',
        'link',
        'strike',
        'script',
        'underline',
        'blockquote',
        'header',
        'indent',
        'list',
        'align',
        'direction',
        'code-block',
    ],
    contentMediaType: {
        HTML: 'HTML',
        DOCUMENT: 'DOCUMENT',
        VIDEO: 'VIDEO',
        AUDIO: 'AUDIO',
        EXTERNAL: 'EXTERNAL',
    },
    chatbotEvents: {
        CHATBOT_LEARNING_MAP_80: 'LEARNING_MAP_80',
        CHATBOT_LEARNING_MAP_COMPLETED: 'LEARNING_MAP_COMPLETED',
        CHATBOT_CONTENT_RECOMENDATION_EMPTY: 'CONTENT_RECOMENDATION_EMPTY',
        CHATBOT_CONTENT_RATING_1: 'CONTENT_RATING_1',
        CHATBOT_CONTENT_RATING_5: 'CONTENT_RATING_5',
    },

    CHATBOT_USERNAME: '#NOME#',
    chatBotActionPaths: {
        LEARNING_MAP: 'MapaAprendizagem',
        LIST_CATEGORIES: 'ListaCategoria',
        RECOMENDATION: 'Recomendação',
    },

    chatBotLearningMapProperties: {
        FAVORITE_CONTENT_TYPE: 'favoriteContentType',
        SUGGESTION_TIME_OF_THE_DAY: 'suggestionTimeOfTheDay',
        EMAIL_SUGGESTIONS: 'emailSuggestions',
        CLASSIFICATION_IDS: 'classificationIds',
    },
    radialChartTypes: {
        LEARNING_MAP_CHART: 'learningMapButtonChart' as RadialChartType,
        GOAL_CHART: 'goalChart' as RadialChartType,
        MEDIA_CHART: 'mediaChart' as RadialChartType,
    },
    periodOfDay: {
        MORNING: 'MORNING',
        AFTERNOON: 'AFTERNOON',
        EVENING: 'EVENING',
    },
    reports: {
        BIZID_INDIVIDUAL_CONSUMPTION: 'FLOW_CONSUMO_INDIVIDUAL',
    },
    dashboards: {
        CAST_DEFAULT: 'CAST-DEFAULT',
        FLOW_LMS: 'FLOW-LMS',
        FLOW_PLAYLIST: 'FLOW-PLAYLIST',
    },
    SAGA_DELAY: 300,
    MY_CONTENT_ID_TO_REDIRECT_BACK: 'myContentIdToRedirectBack',
    TYPE_OF_TRAINING: 'typeOfTraining',
    uploadFolders: { BAGAGEM_ASSETS_PEOPLE: 'bagagem/assets/people/' },
    imageFolders: { STATIC_ASSETS_BADGES: '/static/assets/badges/%k/' },
    badgeImages: { THUMB: 'thumb.png', THUMB_DISABLED: 'thumb_disabled.png', GRANTED_BG: 'granted_bg.jpg' },
    BADGE_AUTH_CERTIFICATE_LINK: 'https://explorer.hathor.network/transaction/',
    SELECTED_TAB_FOLLOW_MODAL: 'selectedTabFollowModal',
    FOLLOWERS_LIMIT: 10,
    PEOPLE_LIMIT: 12,
    DEFAULT_TIME_ZONE: 'America/Sao_Paulo',
    PROGRAM_CLASS_STUDENT_VIEW_URI: 'lms/students/%p/program-class/%c',
    PROGRAM_CLASS_START_DATE_KEY: '@Afferolab::ProgramClassStartDate',
};
